import { call, put } from 'redux-saga/effects';
import {
    requestGetNotifications,
    requestMarkNotificationRead,
    requestMarkAllNotificationsRead,
    requestDeleteNotification,
    requestSendCustomNotification,
    requestGetUnreadCount, } from '../requests/notification';
import {
    setNotifications,
    appendNotifications,
    updateNotificationRead,
    removeNotification,
    setAllRead,
    setUnreadCount,
} from '../../slices/notification';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetNotifications(action) {
    try {
        const { params = {}, callback } = action.payload;
        const response = yield call(requestGetNotifications, params);
        const { notifications, pagination, unreadCount } = response.data;
        // Cursor mode is oldest-first, so it never replaces the newest-first panel page.
        const cursorMode = params.since !== undefined || params.after_id !== undefined;
        if (!cursorMode) {
            if (params.page && params.page > 1) {
                yield put(appendNotifications({ notifications, pagination, unreadCount }));
            } else {
                yield put(setNotifications({ notifications, pagination, unreadCount }));
            }
        }
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.callback) action.payload.callback(null);
    }
}

export function* handleGetUnreadCount(action) {
    try {
        const response = yield call(requestGetUnreadCount);
        yield put(setUnreadCount({ count: response.data?.count || 0 }));
        if (action.payload?.callback) action.payload.callback(response.data);
    } catch (error) {
        if (action.payload?.callback) action.payload.callback(null);
    }
}

export function* handleMarkNotificationRead(action) {
    try {
        const { id, callback } = action.payload;
        const response = yield call(requestMarkNotificationRead, id);
        yield put(updateNotificationRead({ id }));
        const alsoRead = response.data?.alsoRead || [];
        for (const readId of alsoRead) {
            yield put(updateNotificationRead({ id: readId }));
        }
        if (typeof response.data?.unreadCount === 'number') {
            yield put(setUnreadCount({ count: response.data.unreadCount }));
        }
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleMarkAllNotificationsRead(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestMarkAllNotificationsRead);
        yield put(setAllRead());
        yield put(setUnreadCount({ count: 0 }));
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteNotification(action) {
    try {
        const { id, callback } = action.payload;
        const response = yield call(requestDeleteNotification, id);
        yield put(removeNotification({ id }));
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleSendCustomNotification(action) {
    try {
        const { recipients, subject, body, callback } = action.payload;
        const response = yield call(requestSendCustomNotification, recipients, subject, body);
        yield put(showAlert({ severity: 'success', message: 'Notification sent' }));
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.callback) action.payload.callback(null);
    }
}
